/**
 * TARRANT SPECKLED PAPER v1.1
 * Canvas-based paper texture with tiny colored speckles.
 * Matches the LivingPaper component from tarrant-living.jsx.
 *
 * Auto-initializes on DOMContentLoaded.
 * Call TarrantPaper.render(seed) to re-render with a new color set.
 */

(function(global) {
  'use strict';

  function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function seededRandom(seed) {
    var s = typeof seed === 'string' ? hashString(seed) : seed;
    return function() {
      s = (s * 16807 + 0) % 2147483647;
      return (s - 1) / 2147483646;
    };
  }

  var BASE_COLORS = [
    [220, 75, 115],
    [195, 55, 95],
    [55, 145, 115],
    [35, 125, 95],
    [55, 95, 175],
    [195, 175, 45],
    [215, 125, 45],
    [135, 75, 175]
  ];

  function render(seed) {
    var canvas = document.getElementById('tarrant-paper-canvas');
    var isNew = !canvas;

    if (isNew) {
      canvas = document.createElement('canvas');
      canvas.id = 'tarrant-paper-canvas';
    }

    var dpr = window.devicePixelRatio || 1;
    var w = window.innerWidth;
    var h = Math.max(document.body.scrollHeight, 5000);

    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.cssText = [
      'position:fixed',
      'top:0',
      'left:50%',
      'transform:translateX(-50%)',
      'pointer-events:none',
      'z-index:-1',
      'width:' + w + 'px',
      'height:' + h + 'px',
      'max-width:100%',
      'opacity:0.6',
      'transition:opacity 0.5s ease'
    ].join(';');

    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.scale(dpr, dpr);

    // Use seeded random if seed provided, otherwise Math.random
    var rng = seed ? seededRandom(seed) : Math.random;

    // Paper grain — pixel-level noise for fiber texture
    var imgData = ctx.createImageData(w, h);
    var d = imgData.data;
    for (var p = 0; p < d.length; p += 4) {
      var n = (rng() - 0.5) * 12;
      d[p] = 128 + n;
      d[p+1] = 128 + n;
      d[p+2] = 128 + n;
      d[p+3] = Math.floor(rng() * 8);
    }
    ctx.putImageData(imgData, 0, 0);

    // Neutral dust speckles
    for (var i = 0; i < 18000; i++) {
      ctx.fillStyle = 'rgba(170,160,145,' + (rng() * 0.018) + ')';
      ctx.fillRect(rng() * w, rng() * h, 1, 1);
    }

    // Pick a subset of colors based on seed (shifts the palette)
    var colors = [];
    if (seed) {
      var offset = typeof seed === 'string' ? hashString(seed) : seed;
      for (var k = 0; k < 5; k++) {
        var base = BASE_COLORS[(offset + k) % BASE_COLORS.length];
        var shift = Math.floor((rng() - 0.5) * 40);
        colors.push([
          Math.min(255, Math.max(0, base[0] + shift)),
          Math.min(255, Math.max(0, base[1] + shift)),
          Math.min(255, Math.max(0, base[2] + shift))
        ]);
      }
    } else {
      colors = BASE_COLORS;
    }

    // Grayscale star-asterisk speckles — tiny ✳ marks scattered like flecks
    ctx.lineCap = 'round';
    for (var j = 0; j < 320; j++) {
      var cx = rng() * w, cy = rng() * h;
      var r = 1 + rng() * 1.9;                 // arm length
      var g = 78 + Math.floor(rng() * 40);     // neutral gray 78–118
      var alpha = 0.08 + rng() * 0.20;         // subtle
      ctx.strokeStyle = 'rgba(' + g + ',' + g + ',' + g + ',' + alpha + ')';
      ctx.lineWidth = 0.6;
      ctx.beginPath();
      for (var a = 0; a < 3; a++) {            // 3 crossing lines = 6-point asterisk
        var ang = (Math.PI / 3) * a + rng() * 0.4;
        ctx.moveTo(cx - Math.cos(ang) * r, cy - Math.sin(ang) * r);
        ctx.lineTo(cx + Math.cos(ang) * r, cy + Math.sin(ang) * r);
      }
      ctx.stroke();
    }

    if (isNew) {
      document.body.appendChild(canvas);
    }
  }

  // Auto-init with default colors
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { render(); });
  } else {
    render();
  }

  global.TarrantPaper = {
    render: render
  };

})(typeof window !== 'undefined' ? window : this);
